import Experience from '../Experience.js'
import * as THREE from 'three'
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';



export default class DropNodes
{
    constructor(nodeInfo)
    {
        this.nodeInfo = nodeInfo

        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.time = this.experience.time
        this.input = this.experience.input
        this.font = this.resources.items.daysOne3DFont
        this.verticalOffset = -22

        this.nodeGroup = new THREE.Group()
        this.nodes = []
        
        // Materials
        this.nodeMaterial = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            wireframe: true
            
        })

        this.innerNodeMaterial = new THREE.MeshBasicMaterial({
            color: 0xF7931A,
            wireframe: true
        })

        this.lineMaterial = new THREE.LineBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.5
        })

        this.textMaterial = new THREE.MeshStandardMaterial({
            color: 0xffffff,
            emissive: 0xffffff,
            emissiveIntensity: 0.5         
        })

        // Event Listeners
        this.input.on('mousedown', () => {
            
        })

        this.input.on('mouseup', () => {
            
        })
        
        this.create3DDropTitleText()
        this.createNodes()
    }

    create3DDropTitleText()
    {
        const dropTextGeo = new TextGeometry('DROPS', {
            font: this.font,
            size: 20,
            depth: 1,
            curveSegments: 12,
            bevelEnabled: true,
            bevelThickness: 0.25,
            bevelSize: 0.1,
            bevelOffset: 0,
            bevelSegments: 5
        });

        const dropTextMesh = new THREE.Mesh(dropTextGeo, this.textMaterial)
        dropTextMesh.scale.set(0.065, 0.065, 0.065)
        dropTextMesh.position.y = -8
        dropTextMesh.position.z = 3
        dropTextMesh.position.x = -3.6

        this.scene.add(dropTextMesh)
        
    }
    
    createNodes()
    {
        for(let i = this.nodeInfo.length - 1; i >= 0; i--)
        {
            let nodeData = {}

            const geometry = new THREE.BoxGeometry(2, 2, 2)
            const innerGeometry = new THREE.BoxGeometry(0.5, 0.5, 0.5)        
            
            const mesh = new THREE.Mesh(geometry, this.nodeMaterial)
            const innerMesh = new THREE.Mesh(innerGeometry, this.innerNodeMaterial)
            
            //const randomXOffset = (Math.random() * 2 - 1)
            //console.log('randomXOffset: ', randomXOffset)

            
            mesh.position.y = (i - 1) * 5 + this.verticalOffset
            innerMesh.position.y = (i - 1) * 5 + this.verticalOffset
            //mesh.position.x = randomXOffset
            //innerMesh.position.x = randomXOffset
            
            

            nodeData.geometry = geometry
            nodeData.innerGeometry = innerGeometry
            
            nodeData.mesh = mesh
            nodeData.innerMesh = innerMesh
            nodeData.info = this.nodeInfo[i]

            mesh.userData = nodeData
            mesh.userData.isInteractable = true


            const textGeometry = new TextGeometry( `${nodeData.info.dropNumber}`, {
                font: this.font,
                size: 5,
                depth: 1,
                curveSegments: 12,
                bevelEnabled: true,
                bevelThickness: 0.25,
                bevelSize: 0.1,
                bevelOffset: 0,
                bevelSegments: 5
            } );
    
            // Drop Number 3d Text
            const textMesh = new THREE.Mesh(textGeometry, this.textMaterial)
            textMesh.scale.set(0.1, 0.1, 0.1)
            textMesh.position.y = ((i - 1.5) * 5) + this.verticalOffset + 2.75            
            textMesh.position.z = 2            

            this.nodes.push(mesh)

            this.nodeGroup.add(mesh)
            this.nodeGroup.add(innerMesh)
            this.nodeGroup.add(textMesh)
        }

        this.scene.add(this.nodeGroup)
        this.nodeGroup.position.y = -10
    }

    rotateNodes()
    {
        this.nodes.forEach(nodeMesh => {
            nodeMesh.rotation.y = Math.sin(this.time.elapsed)
            nodeMesh.userData.innerMesh.rotation.y = -Math.sin(this.time.elapsed)
        })
    }

    checkNodeHovers()
    {

    }

    update()
    {
        this.rotateNodes()
    }
}